/**
 * Validate URL for crawler forms
 */
export const validateCrawlerUrl = (value: string): string | true => {
  if (!value?.trim()) {
    return 'URL is required';
  }

  // Check if URL starts with http:// or https://
  if (!value.startsWith('http://') && !value.startsWith('https://')) {
    return 'URL must start with http:// or https://';
  }

  try {
    const url = new URL(value);

    // Ensure there's a hostname
    if (!url.hostname || url.hostname.length === 0) {
      return 'Please provide a valid URL';
    }

    // Check for valid domain structure (must have at least one dot or be localhost/IP)
    const hostname = url.hostname.toLowerCase();
    const isLocalhost = hostname === 'localhost' || hostname.startsWith('127.');
    const isIP = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);
    const hasTLD =
      hostname.includes('.') &&
      hostname.split('.').length >= 2 &&
      hostname.split('.').pop()!.length >= 2;

    if (!isLocalhost && !isIP && !hasTLD) {
      return 'Please provide a complete URL (e.g., https://wikipedia.org)';
    }

    return true;
  } catch {
    return 'Please provide a valid URL';
  }
};

/**
 * Validate that crawler has either linkDepth or maxCost set with valid values
 * Matches backend validation: at least one must be >= 1
 */
export const validateCrawlerLimits = (linkDepth: number, maxCost: string): string | null => {
  const maxCostNum = maxCost && maxCost.trim() !== '' ? parseInt(maxCost) : 0;
  const hasValidLinkDepth = linkDepth && linkDepth >= 1;
  const hasValidMaxCost = maxCostNum >= 1;

  // At least one must be >= 1
  if (!hasValidLinkDepth && !hasValidMaxCost) {
    return 'Either Link Depth (minimum 1) or Maximum Cost (minimum 1) must be set';
  }

  // Check for negative values
  if (linkDepth < 0) {
    return 'Link depth cannot be negative';
  }

  if (maxCostNum < 0) {
    return 'Maximum cost cannot be negative';
  }

  return null;
};

/**
 * Validate crawler name is not empty
 */
export const validateCrawlerName = (name: string): string | null => {
  if (!name.trim()) {
    return 'Please enter a crawler name';
  }
  return null;
};
